import React from "react";
import FormSellerGroup from "features/SellerGroup/components/Form";
import { t } from "i18next";

function InfoDetail({ form }) {
  return <FormSellerGroup hasIsActiveInput={true} form={form} />;
}

export default InfoDetail;
